export interface ICostCenter {
  ocorrenciaNo: number;
  codigo: any;
  titulo: any;
  habilitado: boolean;
  codigoHospede: any;
}
